import { MerchantStateTag } from '@/components/shared/components/MerchantStateTag/MerchantStateTag';
import { Text } from '@/components/shared/components/Text';

export const statusFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.5,
    field: 'status',
    headerName: <Text tId={'STATUS'} />,
    renderCell: (rowData) => (
      <div style={{ minWidth: '100px', display: 'flex', alignItems: 'center' }}>
        <div
          style={{
            minWidth: '120px',
            whiteSpace: 'break-spaces',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            lineHeight: 1.43,
          }}
        >
          <MerchantStateTag status={rowData.row.status} />
        </div>
      </div>
    ),
  };
};
